export function getColumnDefs(rateMetadata: any) {
  return [
    {
      headerName: 'Name',
      field: 'name',
      cellEditor: 'agTextCellEditor',
      cellEditorParams: {
        required: true,
      },
      filter: true,
    },
    {
      headerName: 'Product Group',
      filter: true,
      field: 'product_group',
      valueGetter: (params) => params.data.product_group || 'All Products',
      cellEditorPopup: true,
      cellEditor: 'agRichSelectCellEditor',
      cellEditorParams: {
        values: rateMetadata?.product_groups || [],
      },
    },
    {
      headerName: 'Unit',
      field: 'unit',
      filter: true,
      cellEditorPopup: true,
      cellEditor: 'agRichSelectCellEditor',
      cellEditorParams: {
        values: rateMetadata?.units || [],
      },
    },
  ]
}
